import React from 'react';
import { FormControl, FormControlLabel, InputLabel, Select, Switch, Tooltip } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import { OnwardCheckbox } from '@/components/ShipmentForm/blocks';
import deliveryHours from '@/constants/deliveryHours.json';
import { DAYS, HOLIDAYS, HOURS_TOOLTIP } from './constants';
import { dayHourValue, isDayOpen } from './utils';
import { DayColumn, HolidayColumn, HolidayGrid, HoursGrid, SectionTitle, SubTitle } from './blocks';

const HourSelect = ({ id, label, value, disabled, onChange }) => (
    <FormControl variant="outlined" size="small" fullWidth>
        <InputLabel htmlFor={id}>{label}</InputLabel>
        <Select native inputProps={{ id }} label={label} value={value} disabled={disabled} onChange={onChange}>
            <option aria-label="None" value="" />
            {deliveryHours.hours.map((hour) => (
                <option key={hour.value} value={hour.value}>
                    {hour.text}
                </option>
            ))}
        </Select>
    </FormControl>
);

/**
 * The seven-day hours grid and the holiday closures, shared by the default-hours view and the
 * per-location view — which record they edit is decided by the hook, not here.
 *
 * Day order is positional: index 0 is Sunday, matching `hours_open` and `day_num`.
 */
const HoursSection = ({ chosen, viewOnly, title, callbacks }) => (
    <>
        <div>
            <SectionTitle>
                {title}
                <Tooltip title={HOURS_TOOLTIP} placement="right">
                    <InfoOutlined fontSize="small" color="action" />
                </Tooltip>
            </SectionTitle>
        </div>

        <HoursGrid>
            {DAYS.map(({ value, display }, idx) => (
                <DayColumn key={value}>
                    <FormControlLabel
                        control={<OnwardCheckbox />}
                        label={display}
                        checked={!!isDayOpen(chosen, idx)}
                        disabled={viewOnly}
                        onChange={() => callbacks.toggleDayOpen(idx)}
                    />
                    <HourSelect
                        id={`hours-${value}-open`}
                        label="Open"
                        value={dayHourValue(chosen, idx, 'start')}
                        disabled={viewOnly}
                        onChange={(e) => callbacks.changeDayHours(idx, 'start', e.target.value)}
                    />
                    <HourSelect
                        id={`hours-${value}-close`}
                        label="Close"
                        value={dayHourValue(chosen, idx, 'close')}
                        disabled={viewOnly}
                        onChange={(e) => callbacks.changeDayHours(idx, 'close', e.target.value)}
                    />
                </DayColumn>
            ))}
        </HoursGrid>

        <div>
            <SubTitle>Please select the holidays you are closed for:</SubTitle>
            <HolidayGrid>
                {HOLIDAYS.map((column, columnIdx) => (
                    <HolidayColumn key={columnIdx}>
                        {column.map(({ value, display }) => (
                            <FormControlLabel
                                key={value}
                                control={<Switch color="primary" />}
                                label={display}
                                checked={!!chosen[value]}
                                disabled={viewOnly}
                                onChange={() => callbacks.toggleHoliday(value)}
                            />
                        ))}
                    </HolidayColumn>
                ))}
            </HolidayGrid>
        </div>
    </>
);

export default HoursSection;
